export enum TSErrorLevel {
    SEVERE = <any> 'SEVERE',
    WARNING = <any> 'WARNING',
    INFO = <any> 'INFO'
}



// WEBPACK FOOTER //
// ./src/app/models/enums/TSErrorLevel.ts